export default __webpack_public_path__ + "static/media/icon_car_inmotion.3a78071b.svg";